<ion-grid>

    <ion-row class="ion-align-items-center ion-justify-content-center" id="map-nav-row">
        <ion-icon (click)="previous()" *ngIf="!showCumulative" class="nav-icon" color="medium"
                  name="chevron-back-circle"></ion-icon>

        <ion-label class="period-bracket">[</ion-label>

        <ion-label *ngIf="timeframeContainers?.containers?.length" class="date-label">
            {{ cumulativeDateFrom | date:'yyyy-MM-dd HH:mm' }}
        </ion-label>

        <ion-label>&nbsp; &nbsp;</ion-label>

        <ion-select (ionDismiss)="showTimeframe()" *ngIf="timeframeContainers?.containers?.length"
                    [(ngModel)]="dateToShowAsString" interface="popover"
                    placeholder="Period" value="{{dateToShowAsString}}">
            <ion-select-option *ngFor="let dateToSelect of possibleDates"
                               value="{{dateToSelect.toISOString()}}">
                {{ dateToSelect | date:'yyyy-MM-dd HH:mm' }}
            </ion-select-option>
        </ion-select>

        <ion-label class="period-bracket">[</ion-label>

        <ion-icon (click)="next()" *ngIf="!showCumulative" class="nav-icon" color="medium"
                  name="chevron-forward-circle"></ion-icon>
    </ion-row>

    <ion-row>
        <ion-col size-lg="10" size-xs="12">
            <div [style.height.px]="currentHeight" id="map-container">
                <div #primaryMap id="map-div"></div>
            </div>
        </ion-col>
        <ion-col class="ion-hide-xl-down" size-lg="2">
            <div [style.height.px]="currentHeight" [style.width.px]="60">
                <canvas #canvasScale></canvas>
            </div>
        </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center">
        <ion-col size-xs="3">
            <ion-button (click)="toggleMapSettings()" color="medium" fill="clear" id="map-settings-toggle">
                <ion-icon name="map-outline" slot="start"></ion-icon>
                <ion-icon [name]="showMapSettings ? 'chevron-down' : 'chevron-forward'" slot="end"></ion-icon>
            </ion-button>
        </ion-col>
        <ion-col class="ion-hide-sm-down" size-sm="7">
            <span [innerHTML]="mcText"></span>
        </ion-col>

    </ion-row>

    <ion-row *ngIf="showMapSettings" id="map-settings">
        <ion-col size="12">
            <ion-list lines="none">
                <ion-item>
                    <ion-label>Opacity</ion-label>
                    <ion-range (ionChange)="changeAlpha()" [(ngModel)]="alpha" [max]="1" [min]="0.2" [snaps]="true"
                               [step]="0.2" [ticks]="true" class="settings-range" color="medium" slot="end"></ion-range>
                </ion-item>
                <ion-item>
                    <ion-label>Gauges</ion-label>
                    <ion-toggle (ionChange)="changeShowMarkers()" [(ngModel)]="showMarkers" [checked]="showMarkers"
                                color="medium" slot="end"></ion-toggle>
                </ion-item>
                <ion-item>
                    <ion-label>Speeds</ion-label>
                    <ion-toggle (ionChange)="changeShowSpeedMarkers()" [(ngModel)]="showSpeedMarkers"
                                [checked]="showSpeedMarkers" color="medium" slot="end"></ion-toggle>
                </ion-item>
            </ion-list>
        </ion-col>
    </ion-row>

</ion-grid>
